﻿// usage: decorate links or buttons whose actions should be confirmed with
// a confirm attribute: data-confirm="your confirmation text"
export class Confirm {
    public static Initialize(): void {
        const confirmTargets = document.querySelectorAll('[data-confirm]');

        if (confirmTargets === null) {
            return;
        }

        for (let i = 0; i < confirmTargets.length; ++i) {
            const target = confirmTargets[i];
            const text = (target as HTMLElement).dataset.confirm;
            target.addEventListener(
                'click',
                (event) => {
                    const ok = confirm(text);
                    if (ok) {
                        return;
                    }
                    event.preventDefault();
                },
                false,
            );
        }
    }
}
